<template>
  <v-container>
    <h1>Dashboard</h1>
    <hr />

    <Commands />

    <div v-if="!loading" class="grid-wrapper dashboard-grid">
      <PanelOverview :overview="dashboard.overview" />
    </div>
    <Loader v-else />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import Commands from './Commands'
import PanelOverview from './PanelOverview'

export default {
  name: 'AdminDashboard',
  components: {
    Commands,
    PanelOverview,
  },

  data: () => ({
    dashboard: {},
    loading: true,
  }),

  computed: {
    ...mapGetters('feathers', ['apiDashboardAdmin']),
  },

  created () {
    this.retrieveData()
  },

  methods: {
    async retrieveData (refresh = false) {
      this.loading = true

      try {
        const data = await this.apiDashboardAdmin.find()

        if (data.overview) this.dashboard.overview = data.overview
      } catch (error) {
        this.addErrorAlert(`Could not retrieve the data for the dashboard: ${error.message}`)
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-grid {
  grid-template-rows: auto;
  grid-gap: 35px 30px;

  grid-template-columns: 1fr;
  justify-content: center;

  @include xl {
    grid-template-columns: 375px 1fr 300px;
  }
}

.dashboard-panel {
  max-width: 100%;
  margin: 0 auto;

  ::v-deep {
    & > div:first-of-type {
      background-color: white;
      border: $borderLight;
      border-radius: 4px;
      height: 100%;
      min-height: 400px;
      max-width: 90vw;
      margin: auto;
      padding-top: 15px;

      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .panel-footer .default-btn.link {
        font-size: 16px;
        text-transform: uppercase;
      }
    }

    h2 {
      display: inline-block;
      margin-bottom: 15px;
      font-size: 18px;
    }
  }
}

.p-overview {
  width: 100%;
  @include xl {
    @include gridPos($colS: 1, $colE: 4);
  }
}
</style>
